import ellipsisImage from "../../../../common/images/ellipsis.svg";
import { CertificateStatusEnum } from "../../../../common/enums/CertificateStatusEnum";
import {
    QualificationDetailPageInterface,
    setStatus,
} from "../../QualificationDetailSlice";
import {
    setIsAtQualification,
    setIsCreateCertificateModalOpen,
    setIsEstablishmentCertificate,
    setSelectedQualification,
} from "../../../../modals/CreateCertificateModal/CreateCertificateModalSlice";
import { TertiaryTable } from "@hatch-digital-nl/abs-storybook/legacy";
import { QualificationInterface } from "../../../../common/interfaces/QualificationInterface";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { CertificateInterface } from "../../../../common/interfaces/CertificateInterface";
import { JSX } from "react";
import Skeleton from "react-loading-skeleton";
import { MetaInterface } from "../../../../common/interfaces/MetaInterface";
import { getEstablishmentCertificateColumns } from "../../utils/getEstablishmentCertificateColumns";
import { mapEstablishmentCertificatesToRows } from "../../utils/mapEstablishmentCertificatesToRows";

interface EstablishmentCertificatesProps {
    certificates?: {
        data?: CertificateInterface[];
        meta?: MetaInterface;
    };
    qualificationData?: QualificationInterface;
    certificateIsLoading: boolean;
    certificateIsFetching: boolean;
    qualificationIsLoading: boolean;
}

export const EstablishmentCertificates = (
    props: EstablishmentCertificatesProps,
): JSX.Element => {
    const {
        certificates,
        qualificationData,
        certificateIsLoading,
        certificateIsFetching,
        qualificationIsLoading,
    } = props;
    const qualificationDetail = useAppSelector(
        (state) => state.qualificationDetail,
    ) as QualificationDetailPageInterface;
    const dispatch = useAppDispatch();

    if (
        !certificates ||
        !certificates.data ||
        !certificates.meta ||
        !qualificationData ||
        certificateIsLoading ||
        certificateIsFetching ||
        qualificationIsLoading
    ) {
        return <Skeleton count={6} height={"5rem"} borderRadius={"0.8rem"} />;
    }

    return (
        <TertiaryTable
            data={{
                columns: getEstablishmentCertificateColumns(),
                rows: mapEstablishmentCertificatesToRows(certificates.data),
                total: certificates.meta.total,
            }}
            IconButtonIconUrl={ellipsisImage}
            IconButtonBackgroundColor={"#F3F4F6"}
            checkboxes={false}
            isDataEmpty={certificates.data.length === 0}
            title={"Behaald door vestiging"}
            emptyResultText={
                "Jouw vestiging heeft dit certificaat nog <span>niet</span> behaald."
            }
            currentStatus={
                qualificationDetail.status
                    ? qualificationDetail.status
                    : CertificateStatusEnum.ACTIVE
            }
            onStatusClick={(newStatus: string) =>
                dispatch(setStatus(newStatus))
            }
            onAddCertificateClick={() => {
                dispatch(setIsCreateCertificateModalOpen(true));
                dispatch(setIsAtQualification(true));
                dispatch(setIsEstablishmentCertificate(true));
                dispatch(setSelectedQualification(qualificationData));
            }}
            isBackgroundTransparent={true}
        />
    );
};
